import i18n from 'i18n';
import { ColDef, ValueFormatterParams, ValueGetterParams } from '@ag-grid-community/core';
import GridGroupHeader from 'components/GridGroupHeader';
import { JurisdictionArea } from 'data/jurisdictionArea/jurisdictionArea.types';

export enum JurisdictionAreaMenuActionsType {
  Delete = 'delete',
  Edit = 'edit',
}

export const newJurisdictionArea: JurisdictionArea = {
  id: '',
  SS8ID: '',
  AFID: '',
  AFTYPE: '',
  AFNAME: '',
  ACCESS: '',
  GROUP: '',
  OWNER: '',
};

/**
 * This value must be set in common-grid columnDefsVersion property. So, updating this value
 * forces common-grid to use the in code columnDefs instead of the saved grid setting.
 */
export const jurisdictionAreaColumnDefsVersion = '1';

export const jurisdictionAreaColumnDefs: ColDef[] = [
  {
    headerName: i18n.t('jurisdictionArea.grid.areaName'),
    field: 'SS8ID',
    rowGroup: true,
    hide: true,
    lockVisible: true,
  },
  {
    headerName: i18n.t('jurisdictionArea.grid.afType'),
    field: 'AFTYPE',
    tooltipField: 'AF Type',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    flex: 1,
    minWidth: 240,
  },
  {
    headerName: i18n.t('jurisdictionArea.grid.afName'),
    field: 'AFNAME',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'AF Name',
    flex: 1,
    minWidth: 240,
  },
];

export const jurisdictionAreaAutoGroupColumnDef: ColDef = {
  headerName: i18n.t('jurisdictionArea.grid.areaName'),
  sortable: true,
  filter: 'agTextColumnFilter',
  floatingFilter: true,
  resizable: true,
  flex: 1,
  minWidth: 240,
  headerComponentFramework: GridGroupHeader,
  filterValueGetter: (params: Partial<ValueGetterParams>): string => {
    return params.data?.SS8ID;
  },
  cellRendererParams: {
    suppressCount: true,
  },
};
